import { AccessDeniedError } from './AccessDeniedError';
import { ApiGatewayError } from './ApiGatewayError';
import { BackendError } from './BackendError';
import { FetchApiError } from './FetchApiError';
import { GenericError } from './GenericError';
import { NotFoundError } from './NotFoundError';
import { RecoverableApiError } from './RecoverableApiError';
import { RequestError } from './RequestError';
export function getErrorSource(location) {
    return {
        location,
    };
}
export const createErrorObject = (className) => {
    switch (className) {
        case GenericError.className:
            return Object.create(GenericError.prototype);
        case RequestError.className:
            return Object.create(RequestError.prototype);
        case AccessDeniedError.className:
            return Object.create(AccessDeniedError.prototype);
        case NotFoundError.className:
            return Object.create(NotFoundError.prototype);
        case FetchApiError.className:
            return Object.create(FetchApiError.prototype);
        case RecoverableApiError.className:
            return Object.create(RecoverableApiError.prototype);
        case BackendError.className:
            return Object.create(BackendError.prototype);
        case ApiGatewayError.className:
            return Object.create(ApiGatewayError.prototype);
    }
};
export function getErrorResponseCode(error) {
    return error instanceof RequestError
        ? error.response?.status
        : error instanceof AccessDeniedError
            ? 403
            : error instanceof NotFoundError
                ? 404
                : undefined;
}
